import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Select,
  Icon,
  Td,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Spinner,
  Tooltip,
  Switch,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  FaCheck,
  FaExclamation,
  FaEye,
  FaFileExport,
  FaLink,
  FaPlay,
  FaPlus,
  FaTimes,
  FaReceipt,
  FaMoneyCheck,
  FaTrash,
} from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState, useRecoilState } from "recoil";
import moment from "moment";
import { refreshGlobal } from "../../../atoms/refreshGlobal";
import {
  dateForAPI,
  dateForList,
  dateForListWithHours,
} from "../../../constants/dataFormat";
import PaymentApiNovo from "../../../services/paymentApiNovo";
import DateDropdown from "../../../defaultComponents/dateDropdown";
import { goToAddPaymentNew } from "../../../routes/coordinator";
import { HamburgerIcon } from "@chakra-ui/icons";
import ModalDeleteConfirmation from "./components/modalDeleteConfirmation";
import ModalPaymentDetail from "./components/modalPaymentDetail";
import Pagination from "../../../defaultComponents/pagination";
import { JWTToken } from "../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { CNPJFormater, CPFFormater } from "../../../defaultFunctions/formaters";
import { baseURL } from "../../../services/api";
import md5 from "md5";
import ValueDropdown from "../listaDeVendas/defaultComponent/valueDropdown";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import ModalDetails from "./components/modalDetails";
import { permissions } from "../../../atoms/permissions";
import { customColors } from "../../../atoms/customColors";
import axios from "axios";
import ModalSendACodeToLogin from "./components/modalConfirmTransf";
import ModalConfirmPaymentCode from "./components/ModalConfirmPaymentCode";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";

const userFromLocalStorageString = localStorage.getItem("user");
let idCliente = 0;
let userFromLocalStorage: User = {
  id: 0,
  nome: "",
  email: "",
  ativo: false,
  idLoginTipo: 0,
  apiout: false,
  primeiroAcesso: false,
  expiracaoSenha: "",
  loginControle: {
    idLogin: 0,
    primeiroAcesso: false,
    expiracaoSenha: "",
  },
};

if (userFromLocalStorageString) {
  try {
    userFromLocalStorage = JSON.parse(userFromLocalStorageString);
    idCliente = userFromLocalStorage.id;
  } catch (error) {
    console.error("Failed to parse user from localStorage:", error);
  }
} else {
  console.error("User not found in localStorage");
}

interface User {
  id: number;
  nome: string;
  email: string;
  ativo: boolean;
  idEmpresa?: number | null;
  idCliente?: number | null;
  idVendedor?: number | null;
  idProjeto?: number | null;
  idLoginTipo: number;
  apiout: boolean;
  primeiroAcesso: boolean;
  expiracaoSenha: string;
  idTipoGestor?: number | null;
  loginControle: {
    idLogin: number;
    primeiroAcesso: boolean;
    expiracaoSenha: string;
    celular?: string | null;
    tipo2FA?: string | null;
    isAtivo?: boolean | null;
    idTipoUsuario?: number | null;
  };
}

interface PaymentList {
  atualizadoEm: string;
  codigoBarras: string;
  cliente: {
    ativo: boolean;
    cnpj: string;
    email: string;
    id: number;
    idPlano: number;
    idPromocao: number;
    isCnpj: boolean;
    nome: string;
    nomeFantasia: string;
    razaoSocial: string;
    sobrenome: string;
  };
  pagamentosHistorico: [paymentHistorico];
  criadoEm: string;
  dataPagamento: string;
  descontos: number;
  id: number;
  idCliente: number;
  idStatus: number;
  juros: number;
  observacao: string;
  status: {
    id: number;
    status: string;
  };
  urlArquivo: string;
  urlRecibo: string;
  valorNominal: number;
  valorPagamento: number;
  vencimento: string;
  nomeBeneficiario?: string;
  cnpjBeneficiario?: string;
  chave?: string;
}

export interface paymentHistorico {
  atualizadoEm: string;
  criadoEm: string;
  data: string;
  hora: string;
  id: number;
  idPagamento: number;
  idStatus: number;
  observacao: string;
}

interface StatusTypes {
  [chave: string]: JSX.Element;
}

const statusTypes: StatusTypes = {
  Efetivado: <FaCheck />,
  Processando: <FaExclamation />,
  Pendente: <FaExclamation />,
  "Remessa Gerada": <FaExclamation />,
  "Não efetivado": <FaExclamation />,
  Cancelado: <FaTimes />,
  "Pendente - Consumo": <FaExclamation />,
  "Prazo excedido": <FaTimes />, // Added for expired payments
};

export default function PaymentSolicitationNovo() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState<Array<PaymentList>>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState<Array<paymentHistorico>>(
    []
  );
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const [openDelete, setOpenDelete] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState<PaymentList | null>(
    null
  );
  const [isManual, setIsManual] = useState(false);
  const [idBoleto, setIdBoleto] = useState(0);
  const [details, setDetails] = useState({});
  const colors = useRecoilState(customColors)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0]; //adicionei o id de cliente selecionado 
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const idDoUsuarioLogado = Number(jwtToken.idCliente);
  const perms = useRecoilState(permissions)[0];

  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: moment().startOf("day").format(dateForAPI),
    finalDateFilter: moment().endOf("day").format(dateForAPI),
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);

  let dias =
    moment(filtros.finalDateFilter).diff(filtros.initialDateFilter, "days") >=
    32;

  const navigate = useNavigate();

  async function Export() {
    try {
      setLoading(true);
      const response = await PaymentApiNovo.exportPayment(
        filtros.statusFilter,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        Number(jwtToken.idCliente),
        ""
      );
      fileDownload(response, "pagamentos.xlsx");
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
      setLoading(false);
    }
  }

  const handleVisualizarRecibo = async (id: number) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `https://m2admin.softkuka.com.br/api/Comprovante/pagamento/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && response.data.url) {
        window.open(response.data.url, "_blank");
      } else {
        console.error("Recibo não encontrado ou URL inválida.");
      }
    } catch (error) {
      console.error("Erro ao buscar recibo:", error);
    }
  };

  async function getPaymentList() {
  try {
    setLoading(true);
    
  
    const idParaBusca = selectedId === 0 ? idDoUsuarioLogado : selectedId;
    
    const response = await PaymentApiNovo.getPaymentSolicitation(
      filtros.statusFilter,
      idParaBusca,  // usa a var correta
      filtros.initialDateFilter,
      filtros.finalDateFilter,
      currentPage,
      pageSize,
      search,
      filtros.minValueFilter,
      filtros.maxValueFilter,
      isManual
    );
    console.log("ID usado na busca (Pagamentos):", idParaBusca); // debug
    setSalesList(response.data);
    setPages(
      Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
    );
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.log("error", error);
  }
}

  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  const handleOpenConfirmModal = (payment: PaymentList) => {
    setSelectedPayment(payment);
    setIsConfirmModalOpen(true);
  };

  const getPaymentData = (payment: PaymentList) => {
    return {
      id: payment.id,
      codigoBarras: payment.codigoBarras,
      nomeBeneficiario: payment.nomeBeneficiario,
      cnpjBeneficiario: payment.cnpjBeneficiario,
      dataPagamento: payment.dataPagamento,
      vencimento: payment.vencimento,
      juros: payment.juros,
      descontos: payment.descontos,
      valorPagamento: payment.valorPagamento,
      valorNominal: payment.valorNominal,
      observacao: payment.observacao,
      dataTransferencia: moment().format("YYYY-MM-DDTHH:mm:ss.SSS"),
    };
  };

  const handleConfirmPayment = async () => {
    await getPaymentList();
  };

  // Function to check if payment is expired (more than 1 day old)
  const isPaymentExpired = (criadoEm: string) => {
    const createdDate = moment(criadoEm);
    const currentDate = moment("2025-05-22T09:23:00-03:00"); // Hardcoded for consistency
    const diffInDays = currentDate.diff(createdDate, "days");
    return diffInDays > 1;
  };

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getPaymentList();
    }
  }, [pages]);

  useEffect(() => {
  getPaymentList();
}, [
  search,
  currentPage,
  pageSize,
  refresh,
  filtros.initialDateFilter,
  filtros.finalDateFilter,
  filtros.clientFilter,
  filtros.minValueFilter,
  filtros.maxValueFilter,
  filtros.statusFilter,
  isManual,
  selectedId, 
  idDoUsuarioLogado, 
]);

  const arrayDeStatus = [
    { id: 1, status: "Pendente" },
    { id: 2, status: "Remessa Gerada" },
    { id: 3, status: "Processando" },
    { id: 4, status: "Efetivado" },
    { id: 5, status: "Cancelado" },
    { id: 6, status: "Não Efetivado" },
    { id: 7, status: "Pendente - Consumo" },
  ];

  function onChangeStatusFilter(e: any) {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
  }

  const statusOptions =
    arrayDeStatus &&
    arrayDeStatus.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.status,
      };
    });

  return (
    <Flex flexDir={"column"} height="100%" width="100%" bgColor={colors.WHITE}>
      <Box
        width={"100%"}
        height={"fit-content"}
        mt={"0.3%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex px={8} py={3} alignItems="center">
          <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            color={colors.BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Pagamento Online
          </Text>
        </Flex>
      </Box>
      <Flex
        width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        py={3}
        px={10}
        flexDirection={"column"}
      >
        <Text mb={2} fontWeight={"bold"}>
          Filtros
        </Text>
        <Flex width={"100%"} height={"100%"} justifyContent="space-evenly">
          <DateDropdown filtros={filtros} setFiltros={setFiltros} />
          <ValueDropdown filtros={filtros} setFiltros={setFiltros} />
          <Select
            fontSize={"0.8rem"}
            placeholder="Filtrar por Status"
            maxW={"14%"}
            value={filtros.statusFilter}
            onChange={onChangeStatusFilter}
          >
            {statusOptions.map((item) => (
              <option value={item.value} key={item.key}>
                {item.text}
              </option>
            ))}
          </Select>
          <Flex alignItems="center">
            <Switch
              isChecked={isManual}
              onChange={(e) => setIsManual(e.target.checked)}
              mr={2}
            />
            <Text fontSize={"0.8rem"}>Pagamentos Manuais</Text>
          </Flex>
          <Button
            bgColor={colors.GRAY_NEUTRAL}
            color={colors.WHITE}
            onClick={() => {
              setFiltros(initialValues);
              setIsManual(false);
            }}
          >
            Limpar Filtros
          </Button>
          <Button
            bg={"none"}
            color={colors.BLUEMONEDDBUTTONS}
            isDisabled={loading || dias}
            onClick={() => {
              Export();
            }}
            mx="10px"
            isLoading={loading}
            textTransform={"uppercase"}
            leftIcon={<FaFileExport />}
          >
            <Text fontSize={"0.8rem"}>Exportar</Text>
          </Button>
          <Button
            bgColor={colors.BLUEMONEDDBUTTONS}
            color={colors.WHITE}
            onClick={() => {
              goToAddPaymentNew(navigate);
            }}
          >
            <Icon mr={2} as={FiPlus} />
            Novo Pagamento
          </Button>
        </Flex>
      </Flex>

      {loading ? (
        <Flex
          width={"100%"}
          height={"80vh"}
          mt={"0.1%"}
          justifyContent={"center"}
          alignItems={"center"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <Spinner size={"lg"} color={colors.VARIANT} />
        </Flex>
      ) : (
        <Box
          width={"100%"}
          height={"85%"}
          mt={"0.1%"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <TableContainer>
            <Table variant="striped" colorScheme="blue" size="sm">
              <Thead h="60px" position="sticky" top="0">
                <Tr>
                  <Th
                    w={"300px"}
                    borderRadius={"8px 0 0 8px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Data da Envio
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Beneficiário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    CPF/CNPJ do Beneficiário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Data de Pagamento
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Data do Vencimento
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Juros
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Desconto
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Valor a Pagar
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Situação
                  </Th>
                  <Th
                    w={"300px"}
                    borderRadius={"0 8px 8px 0"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {salesList &&
                  salesList.map((item: PaymentList, index: number) => {
                    const isExpired =
                      (item.status.status === "Pendente" ||
                        item.status.status === "Pendente - Consumo") &&
                      isPaymentExpired(item.criadoEm);
                    const displayStatus = isExpired
                      ? "Prazo excedido"
                      : item.status.status;

                    return (
                      <Tr key={index} cursor="pointer">
                        <Td borderRadius={"8px 0px 0px 8px"}>
                          {moment(item.criadoEm).format(dateForListWithHours)}
                        </Td>
                        <Td>{item.nomeBeneficiario}</Td>
                        <Td>
                          {item.cnpjBeneficiario &&
                          item.cnpjBeneficiario.length === 14
                            ? CNPJFormater(item.cnpjBeneficiario)
                            : item.cnpjBeneficiario
                            ? CPFFormater(item.cnpjBeneficiario)
                            : ""}
                        </Td>
                        <Td>
                          {moment(item.dataPagamento).format(dateForList)}
                        </Td>
                        <Td>
                          {item.vencimento === "0001-01-01T00:00:00"
                            ? ""
                            : moment(item.vencimento).format(dateForList)}
                        </Td>
                        <Td>
                          {item.juros.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td>
                          {item.descontos.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td>
                          {item.valorPagamento.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td>
                          {item.status.status === "Não efetivado" ? (
                            <Tooltip
                              label={
                                item.pagamentosHistorico[
                                  item.pagamentosHistorico.length - 1
                                ].observacao
                              }
                              hasArrow
                              bg={colors.ORANGEMONEDD}
                              color="white"
                              placement="auto-start"
                            >
                              <Flex
                                alignItems={"center"}
                                justifyContent="flex-start"
                              >
                                {statusTypes[displayStatus] || (
                                  <FaExclamation />
                                )}
                                <Flex ml={4}>{displayStatus}</Flex>
                              </Flex>
                            </Tooltip>
                          ) : (
                            <Flex
                              alignItems={"center"}
                              justifyContent="flex-start"
                            >
                              {statusTypes[displayStatus] || <FaExclamation />}
                              <Flex ml={4}>{displayStatus}</Flex>
                            </Flex>
                          )}
                        </Td>
                        <Td borderRadius={"0px 8px 8px 0px"}>
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Options"
                              icon={<HamburgerIcon />}
                              bgColor={colors.BLUEMONEDDBUTTONS}
                              color={colors.WHITE}
                              size={"sm"}
                            />
                            <MenuList>
                              <MenuItem
                                icon={<FaEye />}
                                onClick={() => {
                                  setIsOpen(true);
                                  setPaymentDetails(item.pagamentosHistorico);
                                }}
                              >
                                Visualizar Histórico
                              </MenuItem>
                              <MenuItem
                                icon={<FaPlus />}
                                onClick={() => {
                                  setOpenDetails(true);
                                  setDetails(item);
                                }}
                              >
                                Visualizar Detalhes
                              </MenuItem>
                              {item.idStatus === 4 &&
                                moment(item.dataPagamento).format(
                                  "YYYY-MM-DD 00:00:00"
                                ) <= moment().format("YYYY-MM-DD 23:59:59") && (
                                  <MenuItem
                                    icon={<FaReceipt />}
                                    onClick={() => {
                                      window.open(
                                        `${baseURL}/Comprovante/Pagamento/${
                                          item.chave
                                        }?secret=${md5(String(item.id))}`,
                                        "_blank"
                                      );
                                    }}
                                  >
                                    Visualizar Recibo
                                  </MenuItem>
                                )}
                              {(item.status.status === "Pendente" ||
                                item.status.status === "Pendente - Consumo" ||
                                isExpired) && (
                                <MenuItem
                                  icon={<FaTrash />}
                                  onClick={() => {
                                    setOpenDelete(true);
                                    setIdBoleto(item.id);
                                  }}
                                >
                                  Cancelar Solicitação
                                </MenuItem>
                              )}
                              {(item.status.status === "Pendente" ||
                                item.status.status === "Pendente - Consumo") &&
                                !isExpired && (
                                  <MenuItem
                                    icon={<FaMoneyCheck />}
                                    onClick={() => handleOpenConfirmModal(item)}
                                  >
                                    Pagar
                                  </MenuItem>
                                )}
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
          <ModalDeleteConfirmation
            isOpen={openDelete}
            setIsOpen={setOpenDelete}
            getTransferList={getPaymentList}
            id={idBoleto}
          />
          <ModalPaymentDetail
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            item={paymentDetails}
          />
          <ModalDetails
            isOpen={openDetails}
            setIsOpen={setOpenDetails}
            item={details}
          />
          <ModalConfirmPaymentCode
            isOpen={isConfirmModalOpen}
            setIsOpen={setIsConfirmModalOpen}
            paymentId={selectedPayment?.id || 0}
            valor={selectedPayment?.valorPagamento || 0}
            email={userFromLocalStorage.email}
            onConfirm={handleConfirmPayment}
          />
          <Flex width={"100%"} justifyContent="center" mt={8}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              pageSize={pageSize}
            />
            <Select
              value={pageSize}
              onChange={onChangeSize}
              size="sm"
              ml={5}
              maxW="70px"
              borderRadius="6px"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={25}>25</option>
            </Select>
          </Flex>
        </Box>
      )}
    </Flex>
  );
}
